import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute';
import './portal.css';

const L = (p) => lazy(() => import(`./pages/${p}.js`));
const ClientOptions = L('ClientOptions');
const ThankYou = L('ThankYou');
const LenderReveal = L('LenderReveal');
const StrategyView = L('StrategyView');
const PropertyQualifier = L('PropertyQualifier');
const RenewalComparisonView = L('RenewalComparisonView');
const AdminDashboard = L('AdminDashboard');
const DealForm = L('DealForm');
const DealDetails = L('DealDetails');
const StrategyForm = L('StrategyForm');
const StrategyDetails = L('StrategyDetails');
const RenewalForm = L('RenewalForm');

const fallback = <div className="min-h-screen flex items-center justify-center text-slate-400 text-sm">Loading…</div>;
function Scope({ children }) {
  React.useEffect(() => {
    document.body.classList.add('portal-page');
    return () => document.body.classList.remove('portal-page');
  }, []);
  return <div className="portal-scope"><Suspense fallback={fallback}>{children}</Suspense></div>;
}
const pub = (el) => <Scope>{el}</Scope>;
const adm = (el) => <ProtectedRoute><Scope>{el}</Scope></ProtectedRoute>;

// Client links keep their original paths so anything already in Zoho or a client's inbox still resolves.
export const portalRoutes = [
  <Route key="p1" path="/options/:token" element={pub(<ClientOptions />)} />,
  <Route key="p2" path="/options/:token/thank-you" element={pub(<ThankYou />)} />,
  <Route key="p3" path="/options/:token/reveal" element={pub(<LenderReveal />)} />,
  <Route key="p4" path="/strategy/:token" element={pub(<StrategyView />)} />,
  <Route key="p5" path="/strategy/:token/check-property" element={pub(<PropertyQualifier />)} />,
  <Route key="p6" path="/renewal/:token" element={pub(<RenewalComparisonView />)} />,
  <Route key="p7" path="/renewal/:token/reveal" element={pub(<LenderReveal mode="renewal" />)} />,
  <Route key="a1" path="/admin/portal" element={adm(<AdminDashboard />)} />,
  <Route key="a2" path="/admin/portal/deals/new" element={adm(<DealForm />)} />,
  <Route key="a3" path="/admin/portal/deals/:dealId" element={adm(<DealDetails />)} />,
  <Route key="a4" path="/admin/portal/deals/:dealId/edit" element={adm(<DealForm />)} />,
  <Route key="a5" path="/admin/portal/strategies/new" element={adm(<StrategyForm />)} />,
  <Route key="a6" path="/admin/portal/strategies/:strategyId" element={adm(<StrategyDetails />)} />,
  <Route key="a7" path="/admin/portal/strategies/:strategyId/edit" element={adm(<StrategyForm />)} />,
  <Route key="a8" path="/admin/portal/renewals/new" element={adm(<RenewalForm />)} />,
  <Route key="a9" path="/admin/portal/renewals/:renewalId/edit" element={adm(<RenewalForm />)} />,
];
